<template>
    <a-row class="vh-100" type="flex" align="middle" justify="center">
        <a-col :xs="24" :sm="24" :md="6" :lg="6">
            <a-card>
                <a-form class="login-form" @submit.prevent="send">
                    <a-form-item
                        :label="lang.password_recover.email_label"
                        :validate-status="hasError('email') ? 'error' : ''" :has-feedback="true"
                        :help="getError('email')">
                            <a-input
                                id="email"
                                v-model="user.email"
                                type="email"
                                :placeholder="lang.password_recover.email_placeholder"
                                @keyup="removeError('email')">
                                    <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
                            </a-input>
                    </a-form-item>
                    <a-form-item class="text-center">
                        <a-button
                            type="primary"
                            html-type="submit"
                            :loading="loading"
                            class="login-form-button"
                            block>
                                {{ lang.password_recover.send }}
                        </a-button>
                    </a-form-item>
                    <a-form-item class="text-center">
                        <router-link type="link" to="/login" class="login-form-button" block>
                            {{ lang.password_recover.go_login }}
                        </router-link>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-col>
    </a-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import {sendPasswordReset} from "../../api";

export default {
  data: () => ({
      token: '',
      user: {
        email: '',
      },
    loading: false
  }),
  computed: {
    ...mapGetters({
      lang: 'lang',
      hasError: 'hasError',
      getError: 'getError'
    })
  },
  methods: {
    ...mapActions({
      removeError: 'removeError'
    }),
    send () {
      this.loading = !this.loading
      sendPasswordReset(this.user)
        .then(() => {
          this.$notification.open({
            message: 'Éxito!',
            description: 'Se ha enviado un correo para recuperar su contraseña a la dirección indicada',
            duration: 0,
            icon: () => (<a-icon type="smile" style="color: #48BE83" />),
          });
        })
        .catch(() => {
          this.$notification.open({
            message: 'Error',
            description: 'No fue encontrado un usuario con la dirección de correo ingresada',
            duration: 0,
            icon: () => (<a-icon type="warning" style="color: red" />),
          });
        })
        .finally(() => this.loading = !this.loading)
    }
  }
}
</script>
